import { ICostBooking } from 'reducers/bookings/models';
import { IResultWithPagination } from 'reducers/models';
export interface ITableInvoice {
    fcrNumber: number;
    status: string;
    consignee: string;
    billToParty: string;
    carrier: string;
    etd: string;
    pod: string;
    port: string;
    cpod: string;
    soNum: string;
    icbIndicator: string
    _number?: string[]
}

export interface IIssueInvoices extends IResultWithPagination<IIssueInvoice> { }
export interface ISearchInvoices extends IResultWithPagination<ISearchInvoice> { }

export interface IResponse {
    result: any[]
}
export interface IIssueInvoice {
    fcrId?: number;
    fcrNumber?: string;
    status: string;
    companyCode: string;
    salesAreaRev: string;
    consignee: string | null;
    billToParty: string;
    billingCurrency: string;
    carrier?: string | null;
    etd?: string;
    pod: string;
    por?: string;
    cpod: string | null;
    soNumber?: string;
    icbIndicator: string;
    rowNumber?: number;
}
export interface ISearchInvoice {
    id: number;
    internalInvoiceNumber: string;
    countryCode: string;
    sapInvoiceNumber: string;
    status: string | null;
    invoiceType: string;
    billToParty: string;
    etd: string;
    icbIndicator: string;
    createdDate: string;
    createdBy: string | null;
    documentId?: string;
    salesOrderNumber: string;
    ShipperBECode: string;
    PortOfLoading: string;
    PortOfReceipt: string;
    PortOfDischarge: string;
    PlaceOfDelivery: string;
    CarrierSCACCode: string;
    eta: string
}
export interface IInvoiceTerms {
    EssoRateDetailId: number,
    DocumentId: number
}
export interface ISubmitInvoiceBody {
    Category: string,
    InvoiceCurrency: string,
    InvoiceType: string,
    OutputType: string,
    CommunicationType: string,
    PrintInvoice: boolean,
    Printer: string,
    BilltoPartyCode: string,
    UserId: string,
    CreatedBy: string,
    Remarks: string,
    InvoiceStatus: string,
    InvoiceItems: IInvoiceTerms[]
}
export interface ISubmitInvoice {
    Category: string,
    isBulkInvoice: boolean,
    InvoiceRequests: ISubmitInvoiceBody[]
}
export interface IFcrDetails {
    documentID: number,
    fcrNumber: string,
    status: string,
    type: string,
    consignee: string,
    carrier: string,
    etd: string,
    por: string,
    pol: string,
    pod: string,
    salesOrderNumberAndSalesOrderItem: string,
}
export interface IInvoiceDetails {
    finOpsInvoiceNumber: string,
    billToParty: string,
    countryCode: string,
    companyCode: string,
    id: string,
    creditFinOpsInvoiceNumber: string,
    creditSAPInvoiceNumber: string,
    invoiceType: string,
    sapInvoiceNumber: string,
    invoiceStatus: string,
    createdBy: string,
    createdDate: string,
    paymentTerm: string,
    dueDate: string,
    invoiceCurrency: string,
    invoiceDueDate: string,
    localCurrency: string,
    exchangeRate: string,
    documentAmount: string,
    tax: string,
    documentAmtLoc: string,
    taxLoc: string,
    withholdTaxAmt: string,
    fcrDetails: IFcrDetails[]
    essoRateDetailsModels: ICostBooking[],
    communicationType: string,
    printInvoice: boolean,
    layoutType: string,
    printer: string,
    email: string,
    shipmentTerm: string,
    creditNoteDescription: string,
    creditReasonCode: string,
    creditReasonDescription: string
}
export interface IISSODetails {
    finOpsInvoiceNumber: string,
    billToParty: string,
    countryCode: string,
    id: string,
    creditFinOpsInvoiceNumber: string,
    creditSAPInvoiceNumber: string,
    invoiceType: string,
    sapInvoiceNumber: string,
    invoiceStatus: string,
    createdBy: string,
    createdDate: string,
    paymentTerm: string,
    dueDate: string,
    invoiceCurrency: string,
    invoiceDueDate: string,
    localCurrency: string,
    exchangeRate: string,
    documentAmount: string,
    tax: string,
    documentAmtLoc: string,
    taxLoc: string,
    withholdTaxAmt: string,
    fcrDetails: IFcrDetails[]
    essoRateDetailsModels: ICostBooking[],
    communicationType: string,
    printInvoice: boolean,
    layoutType: string,
    printer: string,
    email: string,
    shipmentTerm: string,
    creditNoteDescription: string,
    creditReasonCode: string,
    creditReasonDescription: string
}
export const emptyInvoiceDetails = {
    finOpsInvoiceNumber: '',
    billToParty: '',
    countryCode: '',
    companyCode: '',
    id: '',
    creditFinOpsInvoiceNumber: '',
    creditSAPInvoiceNumber: '',
    invoiceType: '',
    sapInvoiceNumber: '',
    invoiceStatus: '',
    createdBy: '',
    createdDate: '',
    paymentTerm: '',
    dueDate: '',
    invoiceCurrency: '',
    invoiceDueDate: '',
    localCurrency: '',
    exchangeRate: '',
    documentAmount: '',
    tax: '',
    documentAmtLoc: '',
    taxLoc: '',
    withholdTaxAmt: '',
    fcrDetails: [],
    essoRateDetailsModels: [],
    communicationType: '',
    printInvoice: false,
    layoutType: '',
    printer: '',
    email: '',
    shipmentTerm: '',
    creditNoteDescription: '',
    creditReasonCode: '',
    creditReasonDescription: '',
}
export const emptyIssoDetails = {
    finOpsInvoiceNumber: '',
    billToParty: '',
    countryCode: '',
    id: '',
    creditFinOpsInvoiceNumber: '',
    creditSAPInvoiceNumber: '',
    invoiceType: '',
    sapInvoiceNumber: '',
    invoiceStatus: '',
    createdBy: '',
    createdDate: '',
    paymentTerm: '',
    dueDate: '',
    invoiceCurrency: '',
    invoiceDueDate: '',
    localCurrency: '',
    exchangeRate: '',
    documentAmount: '',
    tax: '',
    documentAmtLoc: '',
    taxLoc: '',
    withholdTaxAmt: '',
    fcrDetails: [],
    essoRateDetailsModels: [],
    communicationType: '',
    printInvoice: false,
    layoutType: '',
    printer: '',
    email: '',
    shipmentTerm: '',
    creditNoteDescription: '',
    creditReasonCode: '',
    creditReasonDescription: '',
}